/**
 * auth/me and profiles/form-data may return wholesalers_dealers as array or { data: [] }.
 */
export function normalizeWholesalersDealersList(dealers) {
  if (!dealers) {
    return [];
  }
  if (Array.isArray(dealers)) {
    return dealers;
  }
  if (Array.isArray(dealers.data)) {
    return dealers.data;
  }
  if (typeof dealers === "object") {
    return Object.values(dealers).filter(
      (row) => row && typeof row === "object",
    );
  }
  return [];
}
